import * as CONST from '../utils/constants';
import Util from '../utils/ui';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

class Header {
	constructor() {
		this.body = $('body');

		// header
		this.headerSearchWrap = $('.js-search');
		this.headerOffset = document.getElementById("header").offsetTop;

		// nav
		this.openNavToggle = $('.js-nav-open');
		this.closeNavToggle = $('.js-nav-close');
		this.nav = $('.js-nav');

		// search
		this.searchMegaMenu = $('#header-megamenu-search');
		this.searchMegaMenuBtn = $('#header-megamenu-search + .input-group-btn .btn');
		this.megamenuSearchWrap = $('.primary-nav-search .primary-nav-megamenu');

		this.mouseOver = false;
	}

	init() {
		this.bindEvents();
	}

	bindEvents() {
		// sticky header 
		$(document).on('scroll', e => this.stickyHeader(e));

		// mobile nav
		this.openNavToggle.on('click', e => { e.stopPropagation(); this.toggleNav(); });
		this.closeNavToggle.on('click', e => { e.stopPropagation(); this.toggleNav(); });

		$('.js-primary-nav-toggle-children').on('click', e => { this.mobileNavItem(e) });

		// on enter
		$('.primary-nav > li > a').on('keydown', e => { this.tabbingNav(e) });
		$('.js-search-tabbing').on('keydown', e => { this.tabbingSearch(e) });
		$('.js-search-tabbing').on('click', e => { this.toggleSearch(e) });

		// on blur of megamenu search, remove focused class from nav item
		this.searchMegaMenuBtn.on('blur', e => { $('.js-search-tabbing').closest('li').removeClass('focused') });

		$('.js-nav-back').on('click', e => { this.mobileNavItemBack(e) });

		// on mouseenter, set to true, on mouseleave - close megamenu
		$(".primary-nav-megamenu")
			.on('mouseenter', e => { this.mouseOver = true; })
			.on('mouseleave', e => {
				if (this.mouseOver === true) {
					$('.primary-nav > li').removeClass('open');
					$('.js-nav-dropdown-toggle').removeClass('open');
					this.megamenuSearchWrap.removeClass('open');
				}
			});

		// utilities menu toggle
		this.nav.on('click', e => { e.stopPropagation(); });

		$(window).on('resize', e => this.onResize(e));

		$(window).on('click', e => {
			$('.primary-nav > li').removeClass('focused');
		});
	}

	onResize(e) {
		if (Util.getViewPort() === CONST.ViewPort.Desktop) {
			// if on desktop, close all mobile navs
			if (this.nav.hasClass('open')) {
				enableBodyScroll(this.nav);
				this.nav.removeClass('open-subnav');
				this.nav.find('li').removeClass('open');
				$('.js-nav-dropdown-toggle').removeClass('open');
			}
		}
	}

	// if user hits enter when tabbing on menu items, open mega menu and set tabbing to children
	tabbingNav(e) {
		let target = $(e.currentTarget);

		if (e.keyCode === 13 && target.hasClass('primary-nav-has-children')) {
			e.preventDefault();
			target.closest('li').addClass('focused');
		}

		let $activeElem = $(document.activeElement);
		let $prevItem = $activeElem.closest('li').prev();

		if ($prevItem.hasClass('focused')) {
			$prevItem.removeClass('focused');
		}
	}

	tabbingSearch(e) {
		let target = $(e.currentTarget);

		if (e.keyCode === 13) {
			e.preventDefault();
			target.closest('li').addClass('focused');

			this.searchMegaMenu.focus();
		}

		let $activeElem = $(document.activeElement);
		let $prevItem = $activeElem.closest('li').prev();

		if ($prevItem.hasClass('focused')) {
			$prevItem.removeClass('focused');
		}
	}

	toggleSearch(e) {
		$('.primary-nav > li').removeClass('open');
		$('.js-nav-dropdown-toggle').removeClass('open');

		this.megamenuSearchWrap.toggleClass('open');
		this.searchMegaMenu.focus();
	}

	// toggle nav open/close
	toggleNav(e) {
		this.body.toggleClass('nav-open');
		this.nav.toggleClass('open');

		if (this.nav.hasClass('open')) {
			disableBodyScroll(this.nav);
		}
		else {
			enableBodyScroll(this.nav);
			this.nav.removeClass('open-subnav');
			this.nav.find('li').removeClass('open');
			$('.js-nav-dropdown-toggle').removeClass('open');
		}
	}

	// back link on mobile nav items
	mobileNavItemBack(e) {
		let target = $(e.currentTarget);
		let parentLI = target.closest('li');
		let parentList = target.closest('.js-nav-dropdown-toggle');

		parentLI.removeClass('open');
		this.nav.removeClass('open-subnav');
		parentList.removeClass('open').removeAttr('style');
	}

	// clicking on items in mobile nav
	mobileNavItem(e) {
		e.preventDefault();
		let target = $(e.currentTarget);
		let parent = target.closest('li');
		let targetChildren = parent.find('> .js-nav-dropdown-toggle');
		let isCurrentlyOpen = parent.hasClass('open');

		// remove from all first
		$('.primary-nav > li').removeClass('open');
		$('.js-nav-dropdown-toggle').removeClass('open');
		this.megamenuSearchWrap.removeClass('open');

		if (targetChildren.length > 0) {
			if (!isCurrentlyOpen) {
				targetChildren.addClass('open');
				parent.addClass('open');		
			}

			if (Util.getViewPort() !== CONST.ViewPort.Desktop) {
				this.nav.toggleClass('open-subnav');
			}
		}
	}

	stickyHeader(e) {
		if ($(document).scrollTop() > this.headerOffset) {
			$('#header').addClass('header-sticky');
			$('body').addClass('header-sticky');
		}
		else {
			$('#header').removeClass('header-sticky');
			$('body').removeClass('header-sticky');
		}
	}
}

export default Header;